const formats = [
  {
    icon: 'ri-user-line',
    title: 'Разработка ИПР для отдельных сотрудников',
    desc: 'Для ключевых специалистов или руководителей.',
  },
  {
    icon: 'ri-radar-line',
    title: 'ИПР после оценки компетенций',
    desc: 'Результаты оценки становятся основой индивидуального плана.',
  },
  {
    icon: 'ri-vip-crown-line',
    title: 'Система ИПР для кадрового резерва',
    desc: 'Для подготовки будущих руководителей и ключевых специалистов.',
  },
  {
    icon: 'ri-graduation-cap-line',
    title: 'ИПР после корпоративного обучения',
    desc: 'Помогает перенести результаты тренинга в рабочую практику.',
  },
  {
    icon: 'ri-stack-line',
    title: 'Комплексная система развития',
    desc: 'Оценка → ИПР → обучение → практика → сопровождение → повторная оценка.',
  },
];

export default function WorkFormats() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Форматы работы
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Как можно внедрить ИПР в компании
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {formats.map((f, i) => (
            <div key={i} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-200 transition-colors group">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-200 transition-colors">
                <i className={`${f.icon} text-xl text-teal-700`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{f.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}